export default __webpack_public_path__ + "static/media/nyu.71231eb8.jpg";